import React from 'react';
import { globalTranslationKeys } from '../../../enums';

const {
  FairnessP1,
  FairnessP2,
  FairnessP3,
  FairnessP4,
  FairnessP5,
  FairnessP6,
  FairnessP7,
  FairnessP8,
  FairnessP9,
  FairnessP10,
  FairnessP11,
  FairnessP12,
  Rtp,
  GameRulesP1,
  GameRulesP2,
  GameRulesP3,
  GameRulesP4,
  GameRulesP5,
  GameRulesP6,
  GameRulesP7,
  GameRulesP8,
  GameRulesP9,
  GameRulesP15,
  CancelationMessage1,
  MalfunctionMessage2,
} = globalTranslationKeys;
export const GameSpecificCheckHashPopupTopSection = ({ currentData, isFromBetHistory, t }) => {
  const { CashOut } = globalTranslationKeys;
  return (
    <div className='res-cont-circle-wrp'>
      {isFromBetHistory ? (
        <div className='res-pop-cash-wrp'>
          <p className='res-pop-cash-text'>{t(CashOut)}</p>
          <div className={`res-pop-cash-img orange ${currentData.odd ? 'orange' : 'red'} `}>
            x<span>{currentData.odd}</span>{' '}
          </div>
        </div>
      ) : null}
      <div className={`pascal-res-pop-ins  ${!currentData.roundData ? `passive` : ''} `}>
        <p className='pascal-res-pop-ins-text '>
          {currentData.roundData ? `x${currentData.roundData}` : ''}
        </p>
      </div>
    </div>
  );
};

export const About = ({ t }) => {
  return (
    <div className='fs-help-popup-text'>
      <p className='heading' title={t(GameRulesP1)}>
        {t(GameRulesP1)}
      </p>
      <p className='heading' title={t(GameRulesP2)}>
        {t(GameRulesP2)}
      </p>
      <p className='hasCircle' title={t(GameRulesP3)}>
        {t(GameRulesP3)}
      </p>
      <p className='hasCircle' title={t(GameRulesP15)}>
        {t(GameRulesP15)}
      </p>
      <p className='hasCircle' title={t(GameRulesP9)}>
        {t(GameRulesP9)}
      </p>

      <p className='hasCircle' title={t(CancelationMessage1)}>
        {t(CancelationMessage1)}
      </p>
      <p className='hasCircle' title={t(MalfunctionMessage2)}>
        {t(MalfunctionMessage2)}
      </p>
      <p> {t(Rtp)} </p>
    </div>
  );
};
export const AutoBetPopupTabContent = ({ t }) => {
  return (
    <div className='fs-help-popup-text'>
      <p className='hasCircle' title={t(GameRulesP6)}>
        {t(GameRulesP6)}
      </p>
      <p className='hasCircle' title={t(GameRulesP7)}>
        {t(GameRulesP7)}
      </p>

      <p className='hasCircle' title={t(GameRulesP8)}>
        {t(GameRulesP8)}
      </p>
    </div>
  );
};
export const AutoCashOutPopupTabContent = ({ t }) => {
  return (
    <div className='fs-help-popup-text'>
      <p className='hasCircle' title={t(GameRulesP4)}>
        {t(GameRulesP4)}
      </p>
      <p className='hasCircle' title={t(GameRulesP5)}>
        {t(GameRulesP5)}
      </p>
    </div>
  );
};

export const AboutHashInnerContent = ({ t }) => {
  return (
    <>
      <p className='pr-f-text' title={t(globalTranslationKeys.FairnessModalTitle)}>
        {t(globalTranslationKeys.FairnessModalTitle)}
      </p>

      <p className='pr-f-text' title={t(FairnessP1)}>
        {t(FairnessP1)}
      </p>
      <p className='pr-f-text w-b-ba'>
        CE545547F79996444E87E12DC16F647C8E8EA2A0D948319D22DC930E8728047E2F91285D1CFD8805E9F764982D8328D11F3456354FA208EBEA78FA6693C03DB3
      </p>
      <p className='pr-f-text' title={t(FairnessP2)}>
        {t(FairnessP2)}
      </p>
      <p className='pr-f-text' title={t(FairnessP3)}>
        {t(FairnessP3)}
      </p>
      <p className='pr-f-text' title={t(FairnessP4)}>
        {t(FairnessP4)}
      </p>
      <p className='pr-f-text' title={t(FairnessP5)}>
        {t(FairnessP5)}
      </p>
      <p className='pr-f-text' title={t(FairnessP6)}>
        {t(FairnessP6)}
      </p>
      <p className='pr-f-text' title={t(FairnessP7)}>
        {t(FairnessP7)}
      </p>
      <p className='pr-f-text' title={t(FairnessP8)}>
        {t(FairnessP8)}
      </p>
      <p className='pr-f-text' title={t(FairnessP9)}>
        {t(FairnessP9)}
      </p>
      <p className='pr-f-text' title={t(FairnessP10)}>
        {t(FairnessP10)}
      </p>
      <p className='pr-f-text' title={t(FairnessP11)}>
        {t(FairnessP11)}
      </p>
      <p className='pr-f-text w-b-ba'>
        CE545547F79996444E87E12DC16F647C8E8EA2A0D948319D22DC930E8728047E2F91285D1CFD8805E9F764982D8328D11F3456354FA208EBEA78FA6693C03DB3
      </p>
      <p className='pr-f-text' title={t(FairnessP12)}>
        {t(FairnessP12)}
      </p>
    </>
  );
};

export const HelpPopupContent = ({ t }) => {
  const { CancelationMessage1, MalfunctionMessage2, GameRulesP1, GameRulesP2, Rtp } =
    globalTranslationKeys;
  return (
    <>
      <p>{t(GameRulesP1)}</p>
      <p>{t(GameRulesP2)}</p>
      <p>{t(CancelationMessage1)}</p>
      <p>{t(MalfunctionMessage2)}</p>
      <p>{t(Rtp)}</p>
    </>
  );
};
